var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"subtitle-1 font-weight-regular pink--text mr-8 d-inline",attrs:{"depressed":"","x-large":""},on:{"click":_vm.buttonClick}},[_vm._v(_vm._s(_vm.$t('create-shop'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }